// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function() {
    const navbar = document.getElementById('wrapper-navbar');
    if (navbar) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 20) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        });
    }
});